import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);


export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00693E',
                secondary: '#008F44',
                accent: '#C5EDAC',
                error: '#9B0000',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',

                VERMELHO: '#ffb9b9',
                CINZA: '#e6e6e6',
                AZUL: '#c1eef1',
                AMARELO: '#f0e660',
                ROXO: '#ffb1fb',
                VERDE: '#bbffc6',
                MARROM: '#b68f7e',
                BRANCO: 'ffffff'
            },
        },
    },
})